import { sceneOrbitInteractionStarted, userInteracted } from '../../state/appState';

/** Where the SDK renders POI markers and clusters; a tap there is a POI pick, not a grab. */
const POI_LAYER_SELECTOR = '.dsdk-poi-layer';

/**
 * Legacy `controls.onOrbitInteractionStart` — three's OrbitControls `start`, so
 * a pointer or wheel on an orbit scene whose controls are live. The engine
 * reports no gesture start of its own, so the host listens on its container.
 * The user grabbing the scene collapses a half-screen chat on mobile
 * (`AssistantHud`), counts as the first interaction and pauses a virtual tour.
 * `isLive` is false while legacy's controls would be off (the preloader).
 */
export const watchSceneGrab = (container: HTMLElement, isLive: () => boolean): (() => void) => {
  const onGrab = (event: Event): void => {
    if (!isLive()) return;
    const target = event.target as Element | null;
    if (target?.closest?.(POI_LAYER_SELECTOR)) return;
    userInteracted();
    sceneOrbitInteractionStarted();
  };
  container.addEventListener('pointerdown', onGrab);
  container.addEventListener('wheel', onGrab, { passive: true });
  return () => {
    container.removeEventListener('pointerdown', onGrab);
    container.removeEventListener('wheel', onGrab);
  };
};
